import { ContainerHistory } from "./history.styled";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from "react";
import BCPiramide from "../Bc-Piramide/Bc-piramide";
import BCPiramideFull from "../Bc-Piramide-Full/Bc-piramide-full";

const BCHistory = () => {

    useEffect(() => {
        AOS.init();
      }, [])

  return (
    <ContainerHistory >
      <section className="zero banner" >
        <div className="outer">
          <div className="inner">
            <div className="bg one">
            <h2 data-aos="fade-up" data-aos-duration="2000">
                Planeación <br />
                estratégica de mercadeo<br /> 2024
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className="six banner">
        <div className="outer">
          <div className="inner">
            <div className="bg">
            <BCPiramide />
            </div>
          </div>
        </div>
      </section>
      <section className="first banner">
        <div className="outer">
          <div className="inner">
            <div className="bg one">
            <h2 data-aos="fade-up" data-aos-duration="2000">
                Piramide Mercadeo <br /> 2024
              </h2>
              <p data-aos="fade-up" data-aos-duration="2000">
                Para la construcción de nuestra piramide de 2024 hemos definido
                3 variables a las cuales les hemos dado un peso para permitir el
                calculo de un porcentaje que al final nos permitira asignar un
                nivel en nuestra piramide. Las siguientes son las variables
                definidas:
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="second banner">
        <div className="outer">
          <div className="inner">
            <div className="bg">
            <h2 data-aos="zoom-in" data-aos-duration="2000">
                1 <br /> Diferenciación <br /> y Significancia
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className="third banner">
        <div className="outer">
          <div className="inner">
            <div className="bg">
            <h2 data-aos="zoom-in" data-aos-duration="2000">
            2 <br /> Nivel de <br /> Competencia
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className="fourth banner">
        <div className="outer">
          <div className="inner">
            <div className="bg">
            <h2 data-aos="zoom-in" data-aos-duration="2000">
            3 <br /> Apuesta <br/> Estratégica
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className="seven banner" >
        <div className="outer">
          <div className="inner">
            <div className="bg">
            <BCPiramideFull />
            </div>
          </div>
        </div>
      </section>
    </ContainerHistory>
  );
};

export default BCHistory;
